<template>
  <div>
    <div class="vbt-wrapper">
      <div class="workout-name" style="margin-bottom: 16px; text-align: center">
        Your training zones
      </div>
      <div class="metrics-container">
        <div class="vbt-container">
          <div>
            <span class="vbt-label">MAX Velocity</span>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            "
          >
            <div style="font-size: 13px">
              Left: <br /><span class="gray-value">{{
                getPeakVelocityBySide(item, "L")
              }}</span>
              m/s
            </div>
            <div style="font-size: 13px">
              Right: <br /><span class="gray-value">{{
                getPeakVelocityBySide(item, "R")
              }}</span>
              m/s
            </div>
          </div>
        </div>
        <div class="vbt-container">
          <div>
            <span class="vbt-label">AVG Velocity</span>
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            "
          >
            <div style="font-size: 13px">
              Left: <br /><span class="gray-value">{{
                getVelocityBySide(item, "L")
              }}</span>
              m/s
            </div>
            <div style="font-size: 13px">
              Right: <br /><span class="gray-value">{{
                getVelocityBySide(item, "R")
              }}</span>
              m/s
            </div>
          </div>
        </div>
      </div>
      <div
        class="workout-name"
        style="margin: 16px 0 16px 0; text-align: center"
      >
        Time spent in each zone
      </div>
      <div class="metrics-container">
        <div class="vbt-container">
          <div>
            <span class="vbt-label">Left Side</span>
          </div>
          <div
            v-for="item in leftZonePercentages"
            :key="'L-' + item.zone"
            style="font-size: 13px; margin-bottom: 8px"
          >
            <div>
              {{ getZoneName(item.zone) }}:
              <span class="gray-value">{{ item.percentage }}%</span>
            </div>
            <div class="progress-bar-container">
              <div 
                class="progress-bar" 
                :style="{ 
                  width: item.percentage + '%',
                  backgroundColor: getZoneColor(item.zone)
                }"
              ></div>
              <span class="progress-count">{{ item.count }} reps</span>
            </div>
          </div>
        </div>
        <div class="vbt-container">
          <div>
            <span class="vbt-label">Right Side</span>
          </div>
          <div
            v-for="item in rightZonePercentages"
            :key="'R-' + item.zone"
            style="font-size: 13px; margin-bottom: 8px"
          >
            <div>
              {{ getZoneName(item.zone) }}:
              <span class="gray-value">{{ item.percentage }}%</span>
            </div>
            <div class="progress-bar-container">
              <div 
                class="progress-bar" 
                :style="{ 
                  width: item.percentage + '%',
                  backgroundColor: getZoneColor(item.zone)
                }"
              ></div>
              <span class="progress-count">{{ item.count }} reps</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "result-vbt",
  props: {
    item: {
      type: Object,
      required: true,
      default: undefined,
    },
  },
  methods: {
    getVelocityBySide(item, side) {
      if (!item?.historical) return "0.00";
      const velocities = item.historical
        .filter((h) => h.side === side)
        .map((h) => h.velocity || 0);
      if (velocities.length === 0) return "0.00";
      const sum = velocities.reduce((a, b) => a + b, 0);
      return (sum / velocities.length).toFixed(2);
    },
    getPeakVelocityBySide(item, side) {
      if (!item?.historical) return "0.00";
      const velocities = item.historical
        .filter((h) => h.side === side)
        .map((h) => h.velocity || 0);
      if (velocities.length === 0) return "0.00";
      return Math.max(...velocities).toFixed(2);
    },
    getZoneCountsBySide(item, side) {
      if (!item?.secBySec) return {};
      const zoneCounts = {};
      item.secBySec.forEach((h) => {
        const zone = side === "L" ? h.trainingZone?.L : h.trainingZone?.R;
        if (zone !== undefined) {
          zoneCounts[zone] = (zoneCounts[zone] || 0) + 1;
        }
      });
      return zoneCounts;
    },
    getZonePercentagesBySide(item, side) {
      const counts = this.getZoneCountsBySide(item, side);
      const total = Object.values(counts).reduce((sum, count) => sum + count, 0);
      if (total === 0) return {};
      
      const percentages = {};
      Object.entries(counts).forEach(([zone, count]) => {
        if (zone !== '0') {
          percentages[zone] = Math.round((count / total) * 100);
        }
      });
      return percentages;
    },
    getZoneName(zone) {
      const zoneNames = {
        '1': 'Aerobic',
        '2': 'Endurance',
        '3': 'Strength',
        '4': 'Hypertrophy'
      };
      return zoneNames[zone] || zone;
    },
    getZoneColor(zone) {
      const zoneColors = {
        '4': '#FF0000', // red
        '3': '#ed702d', // orange
        '2': '#00FF00', // green
        '1': '#ADD8E6'  // light blue
      };
      return zoneColors[zone] || '#ed702d';
    }
  },
  computed: {
    leftZonePercentages() {
      const percentages = this.getZonePercentagesBySide(this.item, 'L');
      const counts = this.getZoneCountsBySide(this.item, 'L');
      return Object.entries(percentages)
        .map(([zone, percentage]) => ({
          zone,
          percentage,
          count: counts[zone]
        }))
        .sort((a, b) => b.zone - a.zone);
    },
    rightZonePercentages() {
      const percentages = this.getZonePercentagesBySide(this.item, 'R');
      const counts = this.getZoneCountsBySide(this.item, 'R');
      return Object.entries(percentages)
        .map(([zone, percentage]) => ({
          zone,
          percentage,
          count: counts[zone]
        }))
        .sort((a, b) => b.zone - a.zone);
    }
  }
};
</script>

<style scoped>
.vbt-wrapper {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  margin: 8px 0;
  overflow: hidden;
  width: 100%;
}

.workout-name {
  font-size: 16px;
  font-weight: bold;
  color: #3a3a3a;
}

.metrics-container {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.vbt-container {
  display: flex;
  flex-direction: column;
  border-width: 1px;
  background-color: #fff;
  border-color: #e4e4e4;
  border-style: solid;
  border-radius: 16px;
  padding: 16px;
  flex: 1;
  gap: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.vbt-label {
  font-size: 16px;
  color: #3a3a3a;
  font-weight: bold;
}

.vbt-value {
  font-size: 24px;
  font-weight: bold;
  color: #ed702d;
}

.vbt-unit {
  font-size: 14px;
  color: #3a3a3a;
  margin-left: 4px;
}

.gray-value {
  font-size: 20px;
  color: #3a3a3a;
  font-weight: bold;
}

.progress-bar-container {
  width: 100%;
  height: 20px;
  background-color: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 4px;
  position: relative;
}

.progress-bar {
  height: 100%;
  background-color: #ed702d;
  transition: width 0.3s ease;
}

.progress-count {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #3a3a3a;
  font-size: 12px;
  font-weight: bold;
  z-index: 1;
}
</style> 